<template>
  <div class="import-text-dropdown" v-click-outside="closeDropdown">
    <div class="dropdown-menu" :style="dropdownStyle" ref="dropdownMenu">
      <div
        v-for="option in options"
        :ref="'option-' + option.key"
        :key="option.key"
        class="dropdown-item js-import-text-dropdown-text"
        :class="{ '-active': hoveredOption === option.key }"
        @click.prevent="handleItemClick(option, option.key, $event)"
      >
        <span class="js-import-text-dropdown-text">{{ option.label }}</span>
        <span class="submenu-indicator js-import-text-dropdown-text">▶</span>
      </div>
    </div>

    <!-- Sub-menu for text options -->
    <ImportTextDropdownText
      v-if="showSubMenu && selectedOption"
      :key="selectedOption.key"
      :selectedOption="selectedOption"
      :position="subMenuPosition"
      @insert="handleSubMenuInsert"
      @close="closeSubMenu"
    />
  </div>
</template>

<script>
import ImportTextDropdownText from './ImportTextDropdownText.vue';

export default {
  name: 'ImportTextDropdown',
  components: {
    ImportTextDropdownText,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hoveredOption: null,
      mounted: false,
      showSubMenu: false,
      selectedOption: null,
      subMenuPosition: { x: 0, y: 0 },
    };
  },
  computed: {
    dropdownStyle() {
      return {
        zIndex: 9999,
      };
    },
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    closeDropdown(e) {
      if (
        !this.mounted ||
        e.target?.classList?.contains('js-import-text-dropdown')
      ) {
        return;
      }
      this.closeSubMenu();
      this.$emit('close');
    },
    handleItemClick(option, key) {
      this.hoveredOption = key;
      // Show sub-menu for options with texts
      this.$nextTick(() => {
        this.showSubMenu = true;
        this.selectedOption = option;
        this.calculateSubMenuPosition(key);
      });
    },
    calculateSubMenuPosition(key) {
      // const option = this.$refs[`option-${key}`][0];
      const dropdownMenu = this.$refs.dropdownMenu;
      // const rect = event.currentTarget.getBoundingClientRect();
      // console.log('calculateSubMenuPosition', rect);
      // this.subMenuPosition = {
      //   x: rect.right + 5, // Position to the right of the item
      //   y: rect.top, // Align with the top of the item
      // };
      const dims = dropdownMenu.getBoundingClientRect();

      this.subMenuPosition = {
        x: 180,
        y: dropdownMenu?.offsetTop + dims.height / 2 || 0,
      };
    },
    closeSubMenu() {
      this.showSubMenu = false;
      this.selectedOption = null;
      this.hoveredOption = null;
    },
    handleSubMenuInsert(text) {
      this.$emit('insert', text);
    },
  },
};
</script>

<style scoped lang="scss">
.import-text-dropdown {
  position: absolute;
  display: inline-block;
  z-index: 9999;
  left: 0;
  top: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #ccc;
  z-index: 9999;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: block;
  left: inherit;
  top: inherit;
  width: 180px !important;
  padding: 0;
}

.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: rgba(6, 169, 244, 0.1);
    .submenu-indicator {
      opacity: 1;
    }
  }

  &.-active {
    background: rgba(6, 169, 244, 0.3);
    .submenu-indicator {
      opacity: 1;
      transform: translateX(2px);
      color: #06a9f4;
    }
  }
}

.submenu-indicator {
  font-size: 10px;
  color: #666;
  margin-left: 8px;
  transition: transform 0.2s ease;
  opacity: 0.25;
}

.dropdown-item:hover .submenu-indicator {
  transform: translateX(2px);
  color: #06a9f4;
}
</style>
